import { SiteAction, SET_SITE, UPDATE_SITE, REMOVE_SITE } from "./types";

export function setSiteAction(site: any): SiteAction {
    return {
        type: SET_SITE,
        payload: site
    }
}

export function updateSitesAction(updateSites: boolean) {
    return {
        type: UPDATE_SITE,
        payload: updateSites
    }
}

export function removeSiteAction(siteId: string): SiteAction {
    return {
        type: REMOVE_SITE,
        payload: siteId
    };
}